import { createActions } from 'redux-actions';

export const { loadJob, loadedJob, errorJob } = createActions('LOAD_JOB', 'LOADED_JOB', 'ERROR_JOB');
